import { useEffect, useState } from 'react'
import { fetchPasswordGeneratorApp } from '@/services/resource'
import { DEFAULT_PASSWORD_NOTION_TABLE } from '@/config/constants'
import Link from 'next/link'
import { generateCharacterList } from '@/utils/common'
import Image from 'next/image'

export default function PasswordUseCase() {
  const listSyntax = [
    {
      slug: 'with-symbols',
      title: 'Tạo mật khẩu bao gồm ký tự đặc biệt',
    },
    {
      slug: 'alphanumeric',
      title: 'Tạo mật khẩu chỉ sử dụng chữ cái và số',
    },
    {
      slug: 'with-uppercase',
      title: 'Sử dụng mật khẩu chỉ có chữ cái in hoa',
    },
    {
      slug: 'with-lowercase',
      title: 'Tạo mật khẩu chỉ có chữ cái thường',
    },
    {
      slug: 'mixed-case',
      title: 'Kết hợp chữ cái hoa và thường trong mật khẩu',
    },
    {
      slug: 'numeric',
      title: 'Tạo mật khẩu chỉ sử dụng số',
    },
    {
      slug: 'pin-code',
      title: 'Sử dụng mật khẩu dạng mã PIN',
    },
    {
      slug: 'brute-force-resistance',
      title: 'Kết hợp chữ cái hoa, thường và số trong mật khẩu',
    },
    {
      slug: 'memorable',
      title: 'Tạo mật khẩu dễ nhớ với chữ cái và số',
    },
  ]

  const listCharacter = generateCharacterList(8, 22)

  const [listApp, setListApp] = useState([])
  const loadData = async () => {
    try {
      const response = await fetchPasswordGeneratorApp()
      const results = response.data[DEFAULT_PASSWORD_NOTION_TABLE].collection.data.map((item) => {
        return {
          domain: item.Domain[0],
          name: item.Name[0],
          alias: item.Alias[0],
          slug: `app-${item.Alias[0]}`,
        }
      })
      setListApp(results)
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    loadData()
  }, [])
  return (
    <section className="py-24 password-generator-usecase">
      <div className="max-w-[865px] px-5 lg:px-0 mx-auto">
        <h2 className="text-display-md lg:text-display-lg text-heading text-center font-semibold">
          Các trường hợp sử dụng phổ biến
        </h2>
        <div className="my-12 flex items-center gap-2">
          <span className="block h-[1px] bg-primary-HOVER w-full"></span>
          <span className="text-md lg:text-xl text-primary whitespace-nowrap flex-1 font-semibold">
            Thế nào là mật khẩu mạnh
          </span>
          <span className="block h-[1px] bg-primary-HOVER w-full"></span>
        </div>
        <div className="mt-12 rounded-2xl overflow-hidden border-[0.5px] border-solid border-[#EAECF0]">
          <div className="text-xl text-white font-semibold text-center py-4 px-3 bg-[#1B5D25]">
            Theo số ký tự
          </div>
          <div className="columns-2 lg:columns-3 [&>*:nth-child(even)]:bg-[#F9FAFB] gap-0 rounded-bl-2xl overflow-hidden rounded-br-2xl">
            {listCharacter.map((item) => (
              <div
                key={item.slug}
                className="w-full px-6 py-4 font-medium text-sm md:text-md border-[0.5px] border-solid border-b-0 border-r-0 border-[#EAECF0] text-gray-700 hover:bg-[#F9FAFB]"
              >
                <Link
                  href={`/password-generator/${item?.slug}`}
                  className="hover:text-primary-HOVER w-fit"
                >
                  <span className="underline hover:text-primary-HOVER">{item.title}</span>
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-12 rounded-2xl overflow-hidden border-[0.5px] border-solid border-[#EAECF0]">
          <div className="text-xl text-white font-semibold text-center py-4 px-3 bg-[#1B5D25]">
            Theo cú pháp
          </div>
          <div className="columns-2 lg:columns-3  [&>*:nth-child(even)]:bg-[#F9FAFB] gap-0 rounded-bl-2xl overflow-hidden rounded-br-2xl">
            {listSyntax.map((item) => (
              <div
                key={item.slug}
                className="w-full px-6 py-4 font-medium text-sm md:text-md border-[0.5px] border-solid border-b-0 border-r-0 border-[#EAECF0] text-gray-700 hover:bg-[#F9FAFB] min-h-[81px]"
              >
                <Link
                  href={`/password-generator/${item?.slug}`}
                  className="hover:text-primary-HOVER w-fit"
                >
                  <span className="underline hover:text-primary-HOVER">{item.title}</span>
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-12 rounded-2xl overflow-hidden border-solid border-[0.5px] border-[#EAECF0]">
          <div className="text-xl text-white rounded-tl-xl rounded-tr-xl font-semibold text-center py-4 px-3 bg-[#1B5D25]">
            Theo ứng dụng
          </div>
          <div className="lg:columns-3 md:columns-2 columns-1 [&>*:nth-child(even)]:bg-[#F9FAFB] gap-0 rounded-bl-2xl rounded-br-2xl overflow-hidden">
            {listApp.map((item) => (
              <div
                key={item.alias}
                className="w-full px-6 py-4 font-medium text-sm md:text-md border-[0.5px] border-solid border-b-0 border-r-0 border-[#EAECF0] text-gray-700 hover:bg-[#F9FAFB]"
              >
                <Link
                  href={`/password-generator/${item?.slug}`}
                  className="hover:text-primary-HOVER w-fit"
                >
                  <div className="flex items-center gap-3 w-fit">
                    <div className="size-6">
                      <Image
                        src={`https://locker.io/logo/${item.domain}`}
                        width={24}
                        height={24}
                        alt={item.name || 'Locker password generator'}
                        className="object-contain"
                      />
                    </div>
                    <span className="underline hover:text-primary-HOVER">{item.name}</span>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
